// extracted by mini-css-extract-plugin
module.exports = {"box":"box-NrH4uX71","ad":"ad-1EQznkpv"};